function documentations() {
  const lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazy-loaded-img',
  });

  $('.doc--types-item').click(function() {
    $(this).find('.doc--dropdown').slideToggle();
    $(this).toggleClass('open');
  });

  $('#doc-count-results').text($('.doc-ct:not(.hide)').length);

  /**
   * Do we have filters enabled?
   *
   * @return bool
   */
  function hasFiltersEnabled() {
    return $('#doc-search-form .checkbox:checked').length !== 0;
  }

  /**
   * Do we have search enabled?
   *
   * @return bool
   */
  function hasSearchEnabled() {
    return $('input[type=text]').val() !== '';
  }

  /**
   * Get ids of items that must be displayed based on selected search filters.
   *
   * @return array|false Array of ids, or false if filters are off.
   */
  function getItemsIdsForFilters() {
    let ids = [];

    // Get all types and categories we need to display.
    let types = [];
    let categories = [];

    $('#doc-search-form .checkbox:checked').each(function () {
      types.push($(this).attr('data-post-type'));

      const category = $(this).attr('name');

      switch (category) {
        case 'noticetech':
          categories.push('noticetech');
          categories.push('noticet');
          break;

        case 'fichetech':
          categories.push('fichetech');
          categories.push('plantech');
          break;

        default:
          categories.push(category);
          break;
      }
    });

    // Remove possible duplicates.
    types = [...new Set(types)]
    categories = [...new Set(categories)]

    if (types.length === 0 && categories.length === 0) {
      return false;
    }

    // Get items ids that matches types and categories.
    $('.doc-ct').each(function () {
      const docType = $(this).attr('data-post-type');
      const docCategories = $(this).attr('data-docs').split('-');

      let typeOk = types.includes(docType);
      let categoryOk = false;

      categories.forEach(category => {
        if (docCategories.includes(category)) {
          categoryOk = true;
        }
      });

      if (typeOk && categoryOk) {
        ids.push($(this).attr('id'));
      }
    });

    return ids;
  }

  /**
   * Get ids of items that must be displayed based on text search.
   *
   * @return array|false Array of ids, or false if filter if off.
   */
  function getItemsIdsForSearch() {
    let ids = [];

    const searchVal = $('input[type=text]').val();

    if (searchVal === '') {
      return false;
    }

    $('.doc-ct').each(function () {
      if ($(this).attr('data-title').toUpperCase().indexOf(searchVal.toUpperCase()) >= 0 || $(this).attr('data-reference').toUpperCase().indexOf(searchVal.toUpperCase()) >= 0) {
        ids.push($(this).attr('id'));
      }
    });

    return ids;
  }

  /**
   * Show or hide items based on selected search filters and text search.
   */
  function filterItems() {
    // Hide all items by default.
    $('.doc-ct').removeClass('show');
    $('.doc-ct').addClass('hide');

    // If nothing is used, just display the default results.
    let filtersEnabled = hasFiltersEnabled();
    let searchEnabled = hasSearchEnabled();

    if (!filtersEnabled && !searchEnabled) {
      $('.doc-ct[data-post-type="mtn-collection"]').removeClass('hide');
      $('.doc-ct[data-post-type="mtn-collection"]').addClass('show');

      $('#doc-count-results').text($('.doc-ct:not(.hide)').length);

      return;
    }

    // Get ids of items that must be displayed.
    let filtersIds = getItemsIdsForFilters();
    let searchIds = getItemsIdsForSearch();

    // Ensure we have arrays.
    filtersIds = filtersIds || [];
    searchIds = searchIds || [];

    // Filter ids to get intersection of both arrays if necessary.
    let ids = null;

    if (!filtersEnabled) {
      ids = searchIds;
    }
    else if (!searchEnabled) {
      ids = filtersIds;
    }
    else {
      // Both arrays have matches, only return intersection of both.
      ids = filtersIds.filter(function (id) {
        return searchIds.indexOf(id) !== -1;
      });
    }

    // Display items.
    ids.forEach(id => {
      const $el = $('#' + id);

      $el.removeClass('hide');
      $el.addClass('show');
    });

    $('#doc-count-results').text($('.doc-ct:not(.hide)').length);
    lazyLoadInstance.update();
  }

  $('#doc-search-form').submit(function () {
    filterItems();

    return false;
  });

  $('#doc-search-form .checkbox').change(function () {
    filterItems();
  });
}

export { documentations };
